import {ServiceLocation} from '@domain/enum/location.enum';
import {WorkingDay} from '@domain/working-days';
import {Time} from '@shared/time-picker/time';

interface ReferenceModel
{
    id: string;
    name: string;
}

export class Invitation
{
    public readonly clinic: ReferenceModel;

    public readonly specialty: ReferenceModel;

    public readonly subSpecialty?: ReferenceModel;

    public readonly location: ServiceLocation;

    public readonly appointmentsDuration?: Time;

    public readonly intervalBetweenAppointments?: Time;

    public readonly workingDays: WorkingDay[];

    public constructor(
        clinic: ReferenceModel,
        specialty: ReferenceModel,
        location: ServiceLocation,
        workingDays: WorkingDay[],
        appointmentsDuration: Time,
        intervalBetweenAppointments: Time,
        subSpecialty?: ReferenceModel
    )
    {
        this.clinic = clinic;
        this.specialty = specialty;
        this.subSpecialty = subSpecialty;
        this.location = location;
        this.workingDays = workingDays;
        this.appointmentsDuration = appointmentsDuration;
        this.intervalBetweenAppointments = intervalBetweenAppointments;
    }

    private static formatTime(time?: string): Time
    {
        const duration = !!time ? time.split(':') : ['0', '0', '0'];

        return {
            hour: +duration[0],
            minute: +duration[1],
            second: +duration[2]
        };
    }

    public static fromJSON(invitationJSON: any): Invitation
    {
        return new Invitation(
            invitationJSON.clinic,
            invitationJSON.speciality,
            invitationJSON.location,
            invitationJSON.workingDays,
            Invitation.formatTime(invitationJSON.appointmentsDuration),
            Invitation.formatTime(invitationJSON.intervalBetweenAppointments),
            invitationJSON?.subSpeciality
        );
    }
}
